import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import Form from '../Form'
import FormItem from '../Form/FormItem'
import Button from '../General/Button'
import Datepicker from '../Inputs/Datepicker'
import InputText from '../Inputs/InputText'

const AdvancedIncomeForm : React.FC<IAdvancedIncomeForm> = ({onClose, onSubmit}) => {
  const form = useForm()

  const [windowWidth, setWindowWidth] = useState<number>(0)

  const [isDateSelected, setIsDateSelected] = useState<boolean>(false)

  useEffect(() => {
    const { innerWidth } = window
    setWindowWidth(innerWidth)
  }, [])

  return (
    <Form form={form} onSubmit={(values) => onSubmit({...values, isDateSelected})} classes="gap-x-2 p-2">
      <FormItem name="username" classes="lg:col-span-6 col-span-12">
        <InputText small label="Usuario" maxLength={80} />
      </FormItem>

      <FormItem name="reference" classes="lg:col-span-6 col-span-12">
        <InputText small label="Referencia" maxLength={80} />
      </FormItem>

      <FormItem name="description" classes="lg:col-span-12 col-span-12">
        <InputText small label="Descripción" maxLength={150} />
      </FormItem>

      <div className='xl:col-span-6 col-span-12' onClick={() => setIsDateSelected(true)}>
      <FormItem
        name="fromDate"
        classes="xl:col-span-6 col-span-12"
        rules={{
          required: 'Debe especificar la fecha de creación del producto',
        }}
      >
        <Datepicker
          label="Fecha desde"
          calendarPosition={windowWidth + 50 - windowWidth}
        />
      </FormItem>
      </div>

        <div className='xl:col-span-6 col-span-12' onClick={() => setIsDateSelected(true)}>
      <FormItem
        name="toDate"
        classes="xl:col-span-6 col-span-12"
        rules={{
          required: 'Debe especificar la fecha de creación del producto',
        }}
      >
        <Datepicker
          label="Fecha hasta"
          calendarPosition={windowWidth + 50 - windowWidth}
        />
      </FormItem>
        </div>

      <div className="col-span-12 flex space-x-2 mt-4 px-1 mt-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onClose()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          Buscar
        </Button>
      </div>

    </Form>
  )
}

interface IAdvancedIncomeForm {
    onClose: () => void
    onSubmit: (values: any) => void
}

export default AdvancedIncomeForm
